import { useDispatch } from "react-redux";
import { updateSaveBtnServer } from "../../features/post/postSlice";

export default function Save( {postId, isSaved} ) {
  const dispatch = useDispatch();
  const handleSave = () => {       
    dispatch(updateSaveBtnServer({postId, isSaved}));
  };
  return (
    <button
      onClick={handleSave}
      className={isSaved ? "active save-btn" : "save-btn"}
      id="lws-singleSavedBtn"
    >
      <i className="fa-regular fa-bookmark"></i> {isSaved ? "Saved" : "Save"}
    </button>
  );
}
